import { render, staticRenderFns } from "./addReseller.vue?vue&type=template&id=3a316d8c&scoped=true&"
import script from "./addReseller.vue?vue&type=script&lang=js&"
export * from "./addReseller.vue?vue&type=script&lang=js&"
import style0 from "./addReseller.vue?vue&type=style&index=0&id=3a316d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a316d8c",
  null
  
)

export default component.exports